module.exports = __webpack_public_path__ + "static/media/directions.c0778da2.svg";